import React from 'react';
import { Award, Zap, Star, Rocket, CheckCircle, Globe } from 'lucide-react';
import { whyChooseUs } from '../mockData';

const iconMap = {
  award: Award,
  zap: Zap,
  star: Star,
  rocket: Rocket,
  'check-circle': CheckCircle,
  globe: Globe
};

const WhyChoose = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Why Choose <span className="text-blue-500">MidSkale</span>
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Partner with a team that delivers excellence at every step
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {whyChooseUs.map((item, index) => {
            const IconComponent = iconMap[item.icon];
            return (
              <div
                key={item.id}
                className="group p-8 rounded-2xl bg-gradient-to-br from-slate-50 to-blue-50 border border-slate-200 hover:border-blue-400 hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
                style={{ animationDelay: `${index * 50}ms` }}
              >
                <div className="w-14 h-14 bg-white rounded-xl flex items-center justify-center mb-6 shadow-md group-hover:scale-110 group-hover:rotate-3 transition-all duration-300">
                  <IconComponent className="text-blue-500" size={28} />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">{item.title}</h3>
                <p className="text-slate-600 leading-relaxed">{item.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;